import Button from "./component-assets/Button.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import logo from "../img/PCLC.svg";
import ImpersonateBanner from "./component-assets/ImpersonateBanner.jsx";
import ShowMeBanner from "./component-assets/ShowMeBanner.jsx";
import UpdateHeaderBanner from "./component-assets/UpdateHeaderBanner.jsx";
import BetaBanner from "./component-assets/BetaBanner.jsx";
import NoticeBanner from "./component-assets/NoticeBanner.jsx";
import { getSession } from "../services/session";


const Header = (props) => {

    let buttonItem, content, msgItem, bData, dData, banner, spacer, center_content, tagStyle;

    dData = getSession();

    if (props.Refresh === true){
        buttonItem = (<div>
            <Button text={"Refresh"} type={"button"} class={"btn px-4 btn-toolbar btn-primary me-4"} onClick={() => props.setCount(0)}/>
        </div>);
    }
    else{
        buttonItem = (<div className={{"display": "none"}}></div>);
    }
    if (props?.msg){
        msgItem = (<div style={{display: "inline-block", marginRight: "var(--space-2-5)"}}>{props.msg}</div>);
    }
    else{
        msgItem = (<div className={{"display": "none"}}></div>);
    }

    if (props?.content){
        content = props.content;
    }else{
        content = (
            <div className={"col-auto"} style={{"display": "flex"}}>
                {buttonItem}
                {msgItem}
                <div style={{"display": "inline-block"}}>{props?.element ? props.element : <></>}</div>
            </div>
        );
    }

    if (props?.center_content){
        center_content = props.center_content;
    }else{
        center_content = <></>
    }

    spacer = "header-spacerX";
    if (dData?.corp && dData?.myCorp?.toString() !== dData?.corp?.toString()){
        banner = <ImpersonateBanner />;
    }else if ((false) || window.location.hostname === "portalbeta.palcare.com"){
        banner = <BetaBanner />
    }else if ((false) || dData?.notice_message){
        banner = <NoticeBanner />;
    }else if ((false) || (dData?.myVersion && dData?.myVersion !== "" && dData?.myVersion < import.meta.env.VITE_VERSION)){
        banner = <ShowMeBanner />;
    }else if ((false) || (iAmHigherAuthority(10, dData?.role_weight) && dData?.serverVersion &&
              dData?.serverVersion !== "" && dData?.serverVersion < dData?.newestVersion)){
        banner = <UpdateHeaderBanner />;
    }else{
        banner = <></>;
        spacer = "header-spacer";
    }
    tagStyle = {position: "relative", top: "55px"}
    if (props?.tagItem?.colorType === "background"){
        tagStyle["backgroundColor"] = props.tagItem?.color
        tagStyle["borderRadius"] = "20px";
    }else{
        tagStyle["color"] = props.tagItem?.color
    }

    return (
        <>
            <div className={"header"}>
                {banner}
                <div className={"container-fluid"}>
                    <div className={"header-body"}>
                        <div className={"d-flex justify-content-between"}>
                            <div className={"d-flex justify-content-start"}>
                                <div>
                                    <h6 className={"header-pretitle"}>{props?.preTitle ? props.preTitle : ""}</h6>
                                    <h2 className={"header-title mt-2"}>{props?.Title ? props.Title : ""}</h2>
                                    <h5 className={"header-title mt-2 ms-1"}>{props?.subTitle ? props.subTitle : ""}</h5>
                                </div>
                                <div className={"ms-4"}>
                                    {props?.tagItem?.show
                                        ? <p className={"mb-0 fs-3 px-4 py-1 text-white"}
                                             style={tagStyle}>
                                              <i className={"fe fe-tag me-2 no-hover"}></i>{props.tagItem?.name}
                                          </p>
                                        : <></>
                                    }
                                </div>
                            </div>
                            {props?.fullscreen && <div style={{width: "15rem"}}>
                                <img src={logo} alt={"Palcare Logo Dark Varient"}/>
                            </div>
                            }
                            {center_content}
                            {content}
                        </div>
                        {props?.Navigation ? props.Navigation : ""}
                    </div>
                </div>
            </div>
            <div className={spacer}></div>
        </>
    );
};

export default Header;